import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

const L = {
  pt: { t: "Pagamento cancelado", s: "Nenhum valor foi cobrado. Você pode escolher um pacote quando quiser.", back: "Voltar ao início" },
  en: { t: "Payment canceled", s: "No charge was made. You can pick a pack whenever you like.", back: "Back to home" },
  es: { t: "Pago cancelado", s: "No se realizó ningún cargo. Puedes elegir un paquete cuando quieras.", back: "Volver al inicio" },
};

export default function PaymentCancel() {
  const { lang } = useLang();
  const t = L[lang];
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-[#06091a] text-white flex items-center justify-center px-5">
      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full rounded-3xl border border-white/10 bg-[#0c1122]/90 backdrop-blur p-10 text-center"
      >
        <span className="grid place-items-center w-16 h-16 rounded-full bg-white/5 border border-white/15 mx-auto mb-5">
          <XCircle className="w-8 h-8 text-slate-400" />
        </span>
        <h1 className="font-display font-black text-2xl mb-3">{t.t}</h1>
        <p className="text-sm text-slate-400 leading-relaxed">{t.s}</p>
        <Link
          to="/"
          data-testid="cancel-back-btn"
          className="inline-block mt-8 rounded-full border border-white/15 text-white font-bold text-sm px-7 py-3 transition-all duration-200 hover:border-amber-400/50 hover:text-amber-300"
        >
          {t.back}
        </Link>
      </motion.div>
    </div>
  );
}
